"use strict";
const collapseBoxes = document.querySelectorAll(".collapse-box");
collapseBoxes.forEach((collapseBox) => {
    const collapseBoxContent = collapseBox.querySelector(".collapse-box-content .text");
    const toggleButton = collapseBox.querySelector(".collapse-box-toggle");
    toggleButton?.addEventListener("click", () => {
        if (collapseBox.getAttribute("data-collapsed") === "false") {
            toggleButton.setAttribute("aria-expanded", "false");
            collapseBox.setAttribute("data-collapsed", "true");
            collapseBoxContent.style.display = "none";
        }
        else {
            toggleButton.setAttribute("aria-expanded", "true");
            collapseBox.setAttribute("data-collapsed", "false");
            collapseBoxContent.style.display = "flex";
        }
    });
});
